"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var client_1 = require("../client");
var series_1 = tslib_1.__importDefault(require("../system/series"));
var location_1 = tslib_1.__importDefault(require("../system/location"));
var set_1 = tslib_1.__importDefault(require("../system/set"));
var countrytaxcode_1 = tslib_1.__importDefault(require("../system/countrytaxcode"));
var insurance_1 = tslib_1.__importDefault(require("../system/insurance"));
var freefield_1 = tslib_1.__importDefault(require("../system/freefield"));
var vendor_1 = tslib_1.__importDefault(require("../system/vendor"));
var bankrec_1 = tslib_1.__importDefault(require("../system/bankrec"));
var account_1 = tslib_1.__importDefault(require("../system/account"));
var resolve_1 = require("../../util/resources/resolve");
var lodash_1 = require("lodash");
var BaseLineResource = /** @class */ (function (_super) {
    tslib_1.__extends(BaseLineResource, _super);
    function BaseLineResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BaseLineResource, "related", {
        get: function () {
            return {
                account: account_1.default,
                series: series_1.default,
                location: location_1.default,
                set: set_1.default,
                tax_code: countrytaxcode_1.default,
                insurance: insurance_1.default,
                free_field_1: freefield_1.default,
                free_field_2: freefield_1.default,
                free_field_3: freefield_1.default,
                free_field_4: freefield_1.default,
                third_party_vendor: vendor_1.default,
                recon: bankrec_1.default,
                // This is a circular dependency, so we must require it lazily
                offset_by: require('./je/lines').default,
            };
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Get an aggregate sum of lines based on a filter object
     * @param query Filter Params
     */
    BaseLineResource.aggregate = function (query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, content;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrap('/aggregate', query).get()
                        // Negotiate content (this is a list route)
                    ];
                    case 1:
                        result = _a.sent();
                        content = new client_1.PagedContentNegotiator(this, result);
                        return [2 /*return*/, {
                                content: content,
                                amount: content.body.aggregate,
                                currencyCode: content.body.currency_code,
                            }];
                }
            });
        });
    };
    BaseLineResource.aggregateAll = function (query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var firstPage, content, otherPages, allResources, promises;
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.aggregate(query)
                        // This is the Content Negotiator instance (PagedContentNegotiator)
                    ];
                    case 1:
                        firstPage = _b.sent();
                        content = firstPage.content;
                        otherPages = content.otherPageNumbers();
                        allResources = (_a = {},
                            _a[content.page] = content.resources,
                            _a);
                        promises = otherPages.map(function (page) {
                            // Make sure we're calling the same query/filter params, except the page number is different
                            var thisPageQuery = Object.assign({}, query, { page: page });
                            // Return the promise, then when _that_ page is retrieved, push the resources in the content negotiator to the indexed dict defined above (allResources)
                            return _this.aggregate(Object.assign({}, thisPageQuery)).then(function (res) {
                                // Promise is resolved, append these resources
                                allResources[page] = res.content.resources;
                            });
                        });
                        // Resolve all promises
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        // Resolve all promises
                        _b.sent();
                        return [2 /*return*/, {
                                // Once all promises are resolved, return all resources retrieved in this way
                                resources: lodash_1.flatten(Object.values(allResources)),
                                // Also include the amount because that's the primary function of this.aggregate()
                                amount: firstPage.amount,
                                currencyCode: firstPage.currencyCode
                            }];
                }
            });
        });
    };
    BaseLineResource.prototype.save = function (options) {
        if (options === void 0) { options = {}; }
        return _super.prototype.save.call(this, options);
    };
    /**
     * Get replacement line. -- eg. if a line has `offset_by` value, get the drop-in replacement line (note: this is not the line referenced in `offset_by`!)
     */
    BaseLineResource.prototype.getReplacement = function () {
        if (!this.attributes.offset_by) {
            throw new Error(this.toResourceName() + ": Can't find replacement line that isn't offset");
        }
        if ('object' !== typeof this.attributes.replacement_line) {
            throw new Error(this.toResourceName() + ".attributes[replacement_line] is invalid");
        }
        var ReplacementResourceClass = resolve_1.requireResourceByModelName(this.attributes.replacement_line.line_type);
        return ReplacementResourceClass.detail(this.attributes.replacement_line.id);
    };
    return BaseLineResource;
}(base_1.default));
exports.BaseLineResource = BaseLineResource;
//# sourceMappingURL=lines.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/lines.js
// module id = 4PRw
// module chunks = 0